<ng-container *ngIf="!urn">
    <nz-alert nzType="warning" nzMessage="{{modelTitle}} nicht hinterlegt" nzShowIcon></nz-alert>
</ng-container>
<ng-container *ngIf="urn">
    <dh-viewer-forge [urn]="urn"></dh-viewer-forge>
</ng-container>
